import React from 'react'

export const SkipToLink = () => (
  <a href="#main" className="skip-to screenreader-only">
    Skip to content
  </a>
)
